import { okamiHttpGateway } from '@/lib/axios'
import { env } from '@/utils/env.ts'
import { InternalAxiosRequestConfig } from 'axios'

export async function refreshTokenCall(refreshToken?: string) {
  const { data } = await okamiHttpGateway.post<{ token?: string }>(
    '/auth/v2/refresh-token',
    {
      refreshToken,
    },
    {
      withCredentials: true,
      baseURL: env.VITE_API_URL,
    },
  )

  return data.token
}

export const isRefreshTokenCall = (request: InternalAxiosRequestConfig) =>
  !!request.url?.includes('refresh-token')
